import { Icon } from "../../../../../../components";
import EditIcon from "../../../../../../../public/assets/icons/material/round/edit.svg";

import styles from "./DataTableEditableCells.module.scss";

/**
 * Edit icon for editable cells in data tables
 * @returns The edit icon
 */
export const DataTableEditableCellEditIcon = () => {
  return (
    <span className={styles["data-table-body-cell-edit-icon-container"]}>
      <Icon
        svg={EditIcon}
        size="small"
        color="subtle"
        aria-label="Edit cell value"
      />
    </span>
  );
};
